export default "__VITE_ASSET__CKWP_ciQ__"